<template>
    <div class="flex">
        <div class="flex flex-col items-center mt-2 mr-3">
            <div class="ml-1" v-if="timeType === 'past'">
                <svg :class="{'animate-scale': targetIsVisible}" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="24" height="24" rx="6" fill="#A6C71F"/>
                    <path d="M18.2931 6.9596C18.4743 6.77343 18.7209 6.66509 18.9806 6.65752C19.1819 6.65172 19.3803 6.70683 19.5497 6.81563C19.7192 6.92443 19.8519 7.08185 19.9304 7.2673C20.0089 7.45274 20.0296 7.65757 19.9898 7.85497C19.9499 8.05238 19.8515 8.23316 19.7072 8.37367L10.3739 17.707C10.1863 17.8945 9.93199 17.9998 9.66682 17.9998C9.40165 17.9998 9.14733 17.8945 8.95979 17.707L4.95979 13.707C4.86382 13.6149 4.7872 13.5045 4.73442 13.3824C4.68163 13.2602 4.65375 13.1288 4.6524 12.9958C4.65104 12.8627 4.67625 12.7307 4.72654 12.6076C4.77683 12.4844 4.85119 12.3725 4.94527 12.2784C5.03934 12.1843 5.15125 12.11 5.27442 12.0597C5.3976 12.0094 5.52957 11.9842 5.66261 11.9855C5.79565 11.9869 5.92708 12.0148 6.04921 12.0676C6.17134 12.1203 6.28171 12.197 6.37385 12.2929L9.66682 15.5859L18.2931 6.9596Z" fill="white"/>
                </svg>
            </div>

            <div class="-ml-[2px]" v-else-if="timeType === 'next'">
                <svg :class="{'animate-scale': targetIsVisible}" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="36" height="36" rx="6" fill="#F6A02C"/>
                </svg>
            </div>

            <div class="ml-1" v-else>
                <svg :class="{'animate-scale': targetIsVisible}" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="24" height="24" rx="6" fill="#111827"/>
                </svg>

            </div>

            <div v-if="hasLine" class="w-1 mt-2 transition-all duration-[1500ms] ease-out rounded-xl bg-brand-gray-900" :class="{'ml-[6px]': timeType !== 'next', 'h-full': targetIsVisible, 'h-0': !targetIsVisible}"></div>
        </div>

        <div>
            <p class="text-[24px] font-medium" :class="{'text-brand-green': timeType === 'past', 'text-brand-orange': timeType === 'next', 'text-brand-gray-900' : timeType === 'future'}">{{ date }}</p>
            <p class="mt-2 font-semibold text-brand-gray-900 text-big-body">{{ title }}</p>
            <p class="mt-2 font-medium text-brand-gray-900 text-body" :class="{'mb-12': !hasSlot, 'mb-2': hasSlot}">{{ description }}</p>

            <slot />

        </div>

    </div>
</template>

<script>
export default {
    props: {
        date: {
            type: String
        },
        title: {
            type: String
        },
        description: {
            type: String
        },

        //past next future
        timeType: {
            type: String
        },

        hasLine: {
            type: Boolean,
            default: true
        },
        
        targetIsVisible: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        hasSlot() {
            return this.$slots.default && this.$slots.default().findIndex(o => o.type !== Comment) !== -1;
        }
    }
}
</script>

<style>

</style>